import { lazy } from "react";
import { Navigate } from "react-router-dom";

// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";

const Home = Loadable(lazy(() => import("views/home")));
const Solutions = Loadable(lazy(() => import("views/solutions")));
const Developers = Loadable(lazy(() => import("views/developers")));
const About = Loadable(lazy(() => import("views/about")));
const Contact = Loadable(lazy(() => import("views/contact")));

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      index: true,
      element: <Home />,
    },
    {
      path: "/home",
      element: <Navigate to="/" replace />,
    },
    {
      path: "/solutions",
      element: <Solutions />,
    },
    {
      path: "/developers",
      element: <Developers />,
    },
    {
      path: "/about",
      element: <About />,
    },
    {
      path: "/contact",
      element: <Contact />,
    },
  ],
};

export default MainRoutes;
